import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import CalendarPicker from "../../../components/CalenderPicker";
import Dropdown from "../../../components/Dropdown";
import { Input } from "../../../components/Input";
import LeftSide from "../../../components/LeftSide";
import ModalAction from "../../../components/ModalAction";
import ModalSkeleton from "../../../components/ModalSkeleton";
import { Analytics, CouponBlackIcon, DiscountIcon } from "../../../constant";
import { addCouponSchema } from "../../../schema";
import classes from "./AddOrEditCouponsModal.module.css";

const initialValues = {
  couponCode: "",
  couponDiscountAmount: null,
  couponDiscountPercentage: null,
  couponMaxUsage: null,
  couponStartDate: null,
  couponEndDate: null,
  active: true,
};

const AddOrEditCouponsModal = ({ show, setShow, data, onSubmit, additionalParams }) => {
  const [discountType, setDiscountType] = useState(1);
  console.log("additionalParams", additionalParams);
  useEffect(() => {
    if (data) {
      setFieldValue("couponCode", data?.couponCode);
      setFieldValue("couponDiscountAmount", data?.couponDiscountAmount);
      setFieldValue("couponDiscountPercentage", data?.couponDiscountPercentage);
      setFieldValue("couponMaxUsage", data?.couponMaxUsage);
      setFieldValue("couponStartDate", data?.couponStartDate);
      setFieldValue("couponEndDate", data?.couponEndDate);
      setFieldValue("active", data?.active);
    }
  }, [data]);

  const formik = useFormik({
    initialValues,
    validationSchema: addCouponSchema,
    onSubmit: (values, { resetForm }) => {
      if (
        values?.couponDiscountAmount === null &&
        values?.couponDiscountPercentage === null
      ) {
        toast.error("Please enter discount amount or percentage");
        return;
      }
      const params = {
        ...(data?.couponId && { couponId: data?.couponId }),
        couponCode: values?.couponCode,
        couponDiscountAmount:
          discountType === 1 &&
          values?.couponDiscountAmount !== 0 &&
          values?.couponDiscountAmount !== null
            ? values?.couponDiscountAmount
            : null,
        couponDiscountPercentage:
          discountType === 2 &&
          values?.couponDiscountPercentage !== 0 &&
          values?.couponDiscountPercentage !== null
            ? values.couponDiscountPercentage
            : null,
        couponMaxUsage:
          values?.couponMaxUsage === 0 ? null : values?.couponMaxUsage,
        couponStartDate:
          values?.couponStartDate === "Invalid date"
            ? null
            : values?.couponStartDate,
        couponEndDate:
          values?.couponEndDate === "Invalid date"
            ? null
            : values?.couponEndDate,
        active: values?.active,
        delete: false,
        ...(additionalParams?.corporateId && {
          corporateId: additionalParams?.corporateId,
          locationId: null,
          courtId: null,
          // locationId: additionalParams?.location,
        }),
      };

      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
  } = formik;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false);
  };

  const discountTypes = [
    {
      label: "Amount",
      value: 1,
    },
    {
      label: "Percentage",
      value: 2,
    },
  ];

  return (
    <>
      <ModalSkeleton
        width="700px"
        show={show}
        setShow={setShow}
        title={`${data ? "Edit" : "Add"} Coupon`}
      >
        <form onSubmit={handleSubmit}>
          <Row className={classes.controlGrid}>
            <Col md={6}>
              <Input
                leftIcon={<CouponBlackIcon />}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0px" }}
                type="text"
                labelStyle={{ fontSize: "16px" }}
                label={"Coupon Code"}
                placeholder="Enter Coupon Code"
                value={values?.couponCode}
                onChange={(e) => {
                  handleChangeWithTouch("couponCode")(e);
                }}
                errorText={touched?.couponCode && errors?.couponCode}
                disabled={data?.couponId}
              />
            </Col>
            <Col md={6}>
              <Dropdown
                options={discountTypes}
                icon={<LeftSide icon={<CouponBlackIcon />} />}
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                labelStyle={{ fontSize: "16px" }}
                label={"Discount Type"}
                placeholder="Select Discount Type"
                value={discountType}
                onChange={(val) => setDiscountType(val)}
                disabled={data?.couponId}
              />
            </Col>

            <Col md={6}>
              {discountType === 1 ? (
                <Input
                  leftIcon={<LeftSide icon={<DiscountIcon />} right={"Rs."} />}
                  customStyle={{ gap: "15px" }}
                  inputStyle={{ paddingLeft: "0px" }}
                  type="number"
                  labelStyle={{ fontSize: "16px" }}
                  label={"Discount Amount"}
                  placeholder="Enter Discount Amount"
                  value={values?.couponDiscountAmount}
                  onChange={(e) => {
                    handleChangeWithTouch("couponDiscountAmount")(e);
                  }}
                  errorText={
                    touched?.couponDiscountAmount &&
                    errors?.couponDiscountAmount
                  }
                  disabled={data?.couponId}
                />
              ) : (
                <Input
                  leftIcon={<LeftSide icon={<DiscountIcon />} right={"%"} />}
                  customStyle={{ gap: "15px" }}
                  inputStyle={{ paddingLeft: "0px" }}
                  type="number"
                  labelStyle={{ fontSize: "16px" }}
                  label={"Discount Percentage"}
                  placeholder="Enter Discount Percentage"
                  value={values?.couponDiscountPercentage}
                  onChange={(e) => {
                    handleChangeWithTouch("couponDiscountPercentage")(e);
                  }}
                  errorText={
                    touched?.couponDiscountPercentage &&
                    errors?.couponDiscountPercentage
                  }
                  disabled={data?.couponId}
                />
              )}
            </Col>
            <Col md={6}>
              <Input
                leftIcon={<Analytics />}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0px" }}
                type="number"
                labelStyle={{ fontSize: "16px" }}
                label={"Maximum Usuage"}
                placeholder="Enter Maximum Usuage"
                value={values?.couponMaxUsage}
                onChange={(e) => {
                  handleChangeWithTouch("couponMaxUsage")(e);
                }}
                errorText={touched?.couponMaxUsage && errors?.couponMaxUsage}
                isOptional={true}
                disabled={data?.couponId}
              />
            </Col>
            <Col md={6}>
              <CalendarPicker
                label={"Coupon Start Date"}
                labelStyle={{ fontSize: "16px" }}
                value={values?.couponStartDate}
                placeholder="Select Start Date"
                onChange={(e) => {
                  handleChangeWithTouch("couponStartDate")(
                    moment(e).format("YYYY-MM-DD")
                  );
                }}
                isOptional={true}
              />
            </Col>
            <Col md={6}>
              <CalendarPicker
                label={"Coupon End Date"}
                value={values?.couponEndDate}
                labelStyle={{ fontSize: "16px" }}
                placeholder="Select End Date"
                onChange={(e) => {
                  handleChangeWithTouch("couponEndDate")(
                    moment(e).format("YYYY-MM-DD")
                  );
                }}
                isOptional={true}
              />
            </Col>
          </Row>

          <ModalAction type="submit" onCancel={() => setShow(false)} />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default AddOrEditCouponsModal;
